export default __webpack_public_path__ + "static/media/ic-diamond.71335ce4.svg";